import { ModalViewModel } from '@/infra/ModalViewModel'
import { TermsOfUseDocument } from '@/features/account/terms/TermsOfUseDocument'
import { action, observable } from 'mobx'
import { type Id } from '@/infra/id'
import { type TermsOfUseStore } from '@/features/account/terms/TermsOfUseStore'

export class ViewAcceptedTermsDialogViewModel {
  /**
   * The modal state.
   */
  readonly modal = new ModalViewModel()

  /**
   * The terms document.
   */
  @observable accessor terms: TermsOfUseDocument = TermsOfUseDocument.none

  /**
   * Constructor.
   * @param _termsOfUseStore
   */
  constructor(private readonly _termsOfUseStore: TermsOfUseStore) {}

  /**
   * View the terms.
   *
   * @param termsOfUseId
   */
  @action.bound
  view(termsOfUseId: Id) {
    const terms = this._termsOfUseStore.termsOfUseDocuments.get(termsOfUseId)
    if (!terms) {
      return
    }

    this.terms = terms
    this.modal.show()
  }
}
